import React, { PureComponent } from 'react';
import _ from 'lodash';

export default class NewsCard extends PureComponent {
  static defaultProps = {
    img: 'https://source.unsplash.com/user/erondu/400x300',
    title: '',
    onClick: () => null
  };

  render() {
    const { onClick, title, className, img, name } = this.props;
    return (
      <div
        id={name}
        className={`newsCard ${className}`}
        aria-hidden
        style={{ backgroundImage: `url(${img})` }}
        onClick={onClick}
      >
        <div className="text">
          <h3
            className="whiteGray title"
            dangerouslySetInnerHTML={{
              __html: title
            }}
          />
          <h4 className="lightGray readMore">Read</h4>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NewsCard.js